import React, { FC, Fragment } from "react";
import { makeStyles, createStyles, ButtonBase, Divider, Tooltip, Chip, AppBar, Box, Container, Toolbar } from "@material-ui/core";
import { getSalutation } from "../../store/selectors/workspace.selectors";
import { useSelector } from "react-redux";
import { AnnouncementOutlined, ArrowBack, HelpOutline } from "@material-ui/icons";
import SubscriptionStateBanner from "../helpers/subscription-state-banner";

export const APP_BAR_HEIGHT = 24;

const useStyles = makeStyles(theme =>
    createStyles({
        container: {
            marginTop: APP_BAR_HEIGHT
        },
        containerRoot: {
            margin: "0 24px"
        },
        appBarRoot: {
            backgroundColor: "#f8f9fe",
            color: theme.palette.primary.main,
            boxShadow: "none",
            zIndex: 1000
        }
    })
);

const SoloAdminNavbar: FC = props => {
    const classes = useStyles();

    return (
        <Fragment>
            <AppBar position={"sticky"} elevation={0} classes={{ root: classes.appBarRoot }}>
                <Toolbar disableGutters>
                    <Container classes={{ root: classes.containerRoot }}>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} width={"100%"} marginTop={"1rem"} marginBottom={"1rem"}>
                            <Tooltip title={"Starten Sie eine Tour, um unsere Software besser kennen zu lernen."}>
                                <ButtonBase href="/profile" style={{ marginRight: 16, color: "black" }}>
                                    <ArrowBack style={{ width: 20, height: 20, marginRight: 4 }} />
                                    Zurück zum Dashboard
                                </ButtonBase>
                            </Tooltip>

                            <Divider orientation="vertical" style={{ margin: "0 16px", backgroundColor: "white", color: "white", height: "20px" }} />
                        </Box>
                    </Container>
                </Toolbar>
            </AppBar>
            <SubscriptionStateBanner />
            <div id={"app-content"} className={classes.container}>
                {props.children}
            </div>
        </Fragment>
    );
};

export default SoloAdminNavbar;
